import type { EmployeeListItem } from '@/services/human-resources/employee-list/types';
import { isActiveAccount } from './employeeListFilters';

const isNonEmpty = (value: unknown) =>
  value !== null && value !== undefined && String(value).trim() !== '';

export { isActiveAccount };

export const isSharedInternalAccount = (item: EmployeeListItem) => item.accountName === 'cloudbyte';

export const isUndefinedEmployee = (item: EmployeeListItem) => {
  const hasProfile =
    isNonEmpty(item.fullNameKanji) ||
    isNonEmpty(item.fullNameKana) ||
    isNonEmpty(item.fullNameRoma);
  const hasHrAssignment =
    isNonEmpty(item.division) ||
    isNonEmpty(item.department) ||
    isNonEmpty(item.position) ||
    isNonEmpty(item.contractType) ||
    isNonEmpty(item.joiningCompanyDate);

  return !hasProfile || !hasHrAssignment;
};

export const shouldShowInUndefinedEmployeeList = (item: EmployeeListItem) => {
  if (!isActiveAccount(item)) return false;
  if (isSharedInternalAccount(item)) return false;
  return isUndefinedEmployee(item);
};
